import { Controller } from "@hotwired/stimulus"
import Masonry from "masonry-layout"

// Pinterest-style layout: same-width columns, varying heights, left-to-right order.
// Items reserve their height via CSS aspect-ratio, so layout is correct before images load.
export default class extends Controller {
  connect() {
    this.masonry = new Masonry(this.element, {
      itemSelector: "[data-masonry-item]",
      columnWidth: "[data-masonry-sizer]",
      percentPosition: true,
      horizontalOrder: true,
      transitionDuration: 0
    })
    this.relayout = () => this.masonry?.layout()
    this.element.addEventListener("load", this.relayout, true)
    window.addEventListener("load", this.relayout)
  }

  disconnect() {
    this.element.removeEventListener("load", this.relayout, true)
    window.removeEventListener("load", this.relayout)
    this.masonry?.destroy()
    this.masonry = null
  }

  // Absorb items a "load more" fetch appended to this container (wired via
  // load-more:appended, dispatched on this element by load_more_controller).
  // Items reserve height via CSS aspect-ratio, so they position correctly
  // immediately; the capturing "load" listener re-layouts as images arrive.
  append(event) {
    if (!this.masonry) return
    this.masonry.appended(event.detail.items)
    this.masonry.layout()
  }

  // Absorb items a reverse "load more" fetch prepended to the front of this
  // container (wired via load-more:prepended). prepended() puts them ahead of
  // the existing items in layout order — earlier pages sort above later ones —
  // matching their new position in the DOM.
  prepend(event) {
    if (!this.masonry) return
    this.masonry.prepended(event.detail.items)
    this.masonry.layout()
  }

  // Remove the masonry item containing the element that fired the event, then
  // reflow. Wired to a save button's turbo:submit-end so a card drops out of the
  // grid once it's saved. No-op unless the action succeeded.
  removeItem(event) {
    if (!event.detail?.success || !this.masonry) return

    const item = event.target.closest("[data-masonry-item]")
    if (!item) return

    this.masonry.remove(item)
    this.masonry.layout()
  }
}
